import { render } from "./SecondaryButton.vue?vue&type=template&id=26b89efe"
import script from "./SecondaryButton.vue?vue&type=script&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&lang=js"
script.render = render

export default script